// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 єдиний вигляд полос перемикачів — заголовки, відступи, Alt-підказки пунктів): вид — общий SegSwitch; в островке графа — без внешних отступов, впритык к соседним кнопкам */\n.graph-engine-toggle.seg-set { flex: none; margin: 0 4px 0 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
